import React from 'react'
import { useForm, UseFormReturn } from 'react-hook-form'

import { inputProperties } from '../../../types/inputProperties'
import TabbedDeliveryMethod, {
  TabbedDeliveryMethodProps,
} from './components/TabbedDeliveryMethod'
import { WidgetBody } from '../../../base'

/**
 * @param {UseFormReturn} form (Optional) - hook for managing forms with ease
 */
export interface DeliveryMethodProps extends TabbedDeliveryMethodProps {
  type?: inputProperties
  accountNumber?: inputProperties
  routingNumber?: inputProperties
  beneficiary?: inputProperties
  country?: inputProperties
  line1?: inputProperties
  line2?: inputProperties
  city?: inputProperties
  state?: inputProperties
  postalCode?: inputProperties
  payableTo?: inputProperties
  form?: UseFormReturn
  onClickBack?: Function
  onSubmit?: Function
  theme?: object
  title: string
  recipientName?: string
}

/**
 * @see {@link DeliveryMethodProps} extends {@link TabbedDeliveryMethodProps}
 * @param {UseFormReturn} props.form (Optional) - hook for managing forms with ease
 * @param {Function} props.onClickBack (optional) - Callback fired when the user clicks on back button
 * @returns
 */
const DeliveryMethod = (props: DeliveryMethodProps) => {
  const useFormDefault = props.form || useForm()

  const {
    formState: { isSubmitting },
  } = useFormDefault

  const onClickContinue = () => {
    props.onSubmit && props.onSubmit()
  }

  const onClickBack = () => {
    props.onClickBack && props.onClickBack()
  }

  return (
    <WidgetBody
      title={props.title}
      subtitle={`How should we deliver your payment${
        props.recipientName ? ` to ${props.recipientName}` : ''
      }?`}
      onContinue={onClickContinue}
      onBack={onClickBack}
      isSubmitting={isSubmitting}
    >
      <TabbedDeliveryMethod {...props} form={useFormDefault} />
    </WidgetBody>
  )
}

DeliveryMethod.defaultProps = {
  title: 'Delivery Method',
  theme: {},
}

export default DeliveryMethod
